import DefaultModuleListItem from './DefaultModuleListItem';

export default DefaultModuleListItem;
